import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { addProps } from 'utils/recompose';
import { addIntlProps } from 'utils/recompose';
import { injectIntl } from 'react-intl';
import messages from './messages';
import { connect } from 'react-redux';
import { mini, currentBrand } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import styles from './styles.module.scss';
import bmwlogo from './bmw-logo-sidebar.png';
import minilogo from './mini-logo.png';

const mapStateToProps = combineSelectors({
  currentBrand,
  mini,
});

export const isSeriesDetailPath = ({ location }) =>
  location.pathname.split('/')[1] === 'series';

export const isCartPath = ({ location }) => location.pathname.includes('cart');

export const isOrderDashboardPath = ({ location }) =>
  location.pathname === '/dashboard';

export const webshopBrand = ({ mini, bmwWsBrand, miniWsBrand }) =>
  mini ? miniWsBrand : bmwWsBrand;

export const logo = ({ mini }) => {
  return mini ? minilogo : bmwlogo;
};

export const orderSideLinkActive = ({
  isSeriesDetailPath,
  isCartPath,
  isOrderDashboardPath,
}) =>
  isSeriesDetailPath || isCartPath || isOrderDashboardPath
    ? styles.sidenavLinkActive
    : styles.sidenavLink;

export const isLoading = ({ currentBrand }) => {
  return !currentBrand;
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['analyticsNav', 'orderNav', 'bmwWsBrand', 'miniWsBrand'],
  }),
  withRouter,
  connect(mapStateToProps),
  addProps({
    isSeriesDetailPath,
    isCartPath,
    isOrderDashboardPath,
    webshopBrand,
    logo,
    isLoading,
  }),
  addProps({ orderSideLinkActive }),
);
